import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "./common/common";
const apiUrl = RUN_TIME_API_ENDPOINT;

export default {
  login: ({ username, password }) => {
    localStorage.setItem("not_authenticated", "true");
    let url = `${apiUrl}/login`;
    const options = CommonHeaderOption();
    options.method = "POST";
    options.headers = {
      // 'authorization': tokenId,
      "Content-Type": "application/json",
    };
    options.body = JSON.stringify({ email: username, password });
    // console.log('options to login',options);
    return fetch(url, options)
      .then((res) => {
        console.log("res inside AUTH_LOGIN===>", res);
        if (res.status < 200 || res.status >= 300) {
          throw new Error(res.statusText);
        }
        return res.json();
      })
      .then((resp) => {
        console.log("our use ", resp);
        if (resp.status === "success") {
          console.log("resp >>>", resp);
          window.location.href = "/#";
          localStorage.setItem("__state", JSON.stringify(resp.data));
          return Promise.resolve();
        }
        // e.preventDefault();
        console.log("resp our daa -->>", resp.data);
      })
      .catch((error) => {
        localStorage.removeItem("__state");
        return Promise.reject();
      });

    // localStorage.setItem('not_authenticated', 'true');
    // return Promise.reject();
  },
  logout: () => {
    localStorage.setItem("not_authenticated", "true");
    localStorage.removeItem("__state");
    // localStorage.removeItem('role');
    // localStorage.removeItem('login');
    // localStorage.removeItem('user');
    // localStorage.removeItem('avatar');
    // localStorage.removeItem('__state');

    // localStorage.removeItem("__state")
    return Promise.resolve();
  },
  checkError: (params) => {
    const { status } = params;
    if (status === 401 || status === 403) {
      localStorage.removeItem("__state");
      return Promise.reject();
    }
    return Promise.resolve();
  },
  // checkAuth: () => {
  //     return localStorage.getItem('not_authenticated')
  //         ? Promise.reject()
  //         : Promise.resolve();
  // },
  checkAuth: () => {
    return localStorage.getItem("__state")
      ? Promise.resolve()
      : Promise.reject();
  },

  // getPermissions: () => {
  //     const role = localStorage.getItem('role');
  //     return Promise.resolve(role);
  // },
  getPermissions: () => {
    const __state = JSON.parse(localStorage.getItem("__state"));
    const digital_order_system =
      __state && __state.digital_order_system
        ? __state.digital_order_system
        : "isManual";
    return Promise.resolve(digital_order_system);
  },
  getIdentity: () => {
    return {
      id: localStorage.getItem("login"),
      fullName: localStorage.getItem("user"),
      avatar: localStorage.getItem("avatar"),
    };
  },
};
